export default __webpack_public_path__ + "static/media/logisticOrangeRight.6e4dbfd5.svg";